import PropTypes from 'prop-types';
import clsx from 'clsx';
import ShopSearch from '../../components/product/ShopSearch';
import ShopFabric from '../../components/product/ShopFabric';
import ShopProductCategory from '../../components/product/ShopProductCategory';

const ShopSidebar = ({
  sideSpaceClass,
  onSearch,
  fabrics,
  selectedFabrics,
  onFabricChange,
  categoryLabels,
  selectedCategoryLabels,
  onCategoryLabelChange,
}) => {
  return (
    <div className={clsx('sidebar-style', sideSpaceClass)}>
      {/* shop search */}
      <ShopSearch onSearch={onSearch} />

      {/* filter by fabric */}
      <ShopFabric fabrics={fabrics} selectedFabrics={selectedFabrics} onFabricChange={onFabricChange} />

      {/* filter by product category */}
      <div className="mt-35">
        <ShopProductCategory
          categories={categoryLabels}
          selectedCategories={selectedCategoryLabels}
          onCategoryChange={onCategoryLabelChange}
        />
      </div>
    </div>
  );
};

ShopSidebar.propTypes = {
  categoryLabels: PropTypes.array,
  fabrics: PropTypes.array,
  onCategoryLabelChange: PropTypes.func,
  onFabricChange: PropTypes.func,
  onSearch: PropTypes.func,
  selectedCategoryLabels: PropTypes.array,
  selectedFabrics: PropTypes.array,
  sideSpaceClass: PropTypes.string,
};

export default ShopSidebar;
